export enum FacebookAuthProvider {
  FacebookApp = 'facebook_app',
  FacebookWeb = 'facebook_web',
}

export const FACEBOOK_OAUTH_BASE_URL =
  'https://www.facebook.com/v24.0/dialog/oauth';
export const FACEBOOK_OAUTH_SCOPES = ['public_profile', 'email'];
export const FACEBOOK_OAUTH_CONTEXT_KEY = 'FACEBOOK_OAUTH_CONTEXT';
export const FACEBOOK_OAUTH_STATE = 'facebook';
export const FACEBOOK_OAUTH_REDIRECT_URI = '/authenticate/login/third-party';
